import { Extension } from '@tiptap/core';
import MathBlock from './MathBlock';
import MathMark from './MathMark';
import { RuleName } from './texmath';
import { MathToken } from '@scale/shared/types/config';

type MathOptions = {
  allowedRules: RuleName[];
  /** we want this to prevent text like `$5 to $10 dollars` form rendering as latex */
  enableSingleDollarTextMath: boolean;
};

const Math = Extension.create<MathOptions>({
  name: 'MathExtensions',
  addOptions() {
    return {
      allowedRules: [MathToken.DOLLARS],
      enableSingleDollarTextMath: true,
    };
  },
  addExtensions() {
    let inlineRules = this.options.allowedRules;
    if (!this.options.enableSingleDollarTextMath) {
      inlineRules = inlineRules.filter(x => x !== MathToken.DOLLARS);
    }

    return [
      MathBlock.configure({ allowedRules: this.options.allowedRules }),
      MathMark.configure({ allowedRules: inlineRules }),
    ];
  },
});

export default Math;
